import React, { useEffect, useState } from 'react';
import { ScrollBox, Text } from '@ublend-npm/aulaui-core';
import CardView from './CardView';
import NoSpace from './NoSpace';

const RecentlyViewedSpaces = ({
  onfetchRecentlyViewedSpaces,
  recentlyViewedSpaceList,
  onSpaceStar,
  isStaff,
  isEducator,
}: any) => {
  const [spaceList, setSpaceList] = useState([]);

  useEffect(() => {
    onfetchRecentlyViewedSpaces();
  }, []);

  useEffect(() => {
    if (recentlyViewedSpaceList?.length) {
      const assignedAndunAssignedSpaceList = recentlyViewedSpaceList?.map(
        (spaces) => ({
          ...spaces,
          isEducator,
          isStaff,
        })
      );

      setSpaceList(assignedAndunAssignedSpaceList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(recentlyViewedSpaceList)]);

  const cardViewFn = (props) => {
    return (
      <CardView
        {...props}
        onSpaceStar={onSpaceStar}
        onfetchRecentlyViewedSpaces={onfetchRecentlyViewedSpaces}
      />
    );
  };
  const Title = () => (
    <Text tabIndex={0} fontWeight={600} fontSize="1.25rem">
      {' '}
      Recently viewed{' '}
    </Text>
  );
  return spaceList?.length ? (
    <ScrollBox
      // @ts-expect-error
      title={<Title />}
      render={cardViewFn}
      dataSource={spaceList}
      hideScrollbar
      showArrows
    />
  ) : (
    <NoSpace />
  );
};

export { RecentlyViewedSpaces };
